const { createSelector } = require('reselect');
const { beautyInsiderAccountSelector } = require('selectors/user/beautyInsiderAccount/beautyInsiderAccountSelector');

module.exports = createSelector(beautyInsiderAccountSelector, account => account.biAccountId);
